export const RELEASE = __RELEASE__;
